import React, { useState } from 'react'
import { useTranslation } from "react-i18next";
import AllFeedback from './allfeedback'
import Tabs from '../../../components/tabs';
import TabPanel from '../../../components/tabs/tabpanel';
import PracticesFeedback from './practicefeedbacks';
import CoachingFeedback from './coachingfeedbacks';
import GroupCoachingFeedback from './groupcoachingfeedbacks';
import DemonstrationFeedback from './demonstrationfeedbacks';
import OnDemandFeedback from './ondemandfeedbacks';
const list = [
  { id: 1, name: "Client Feedback", labelKey: "clientFeedback", },
  { id: 2, name: "Practice", labelKey: "practice", },
  { id: 3, name: "Coaching", labelKey: "coaching", },
  { id: 4, name: "Group Coaching", labelKey: "groupCoaching", },
  { id: 5, name: "Demonstration Feedbacks", labelKey: "demonstrationFeedbacks", },


];
export default function Feedback() {
  const { t } = useTranslation("mediumFeedbacks");
  // Display-only copy: English `name` values in `list` stay untouched.
  const displayList = React.useMemo(
    () =>
      list.map((item) => ({
        ...item,
        name: t("tabs." + item.labelKey, { defaultValue: item.name }),
      })),
    [t]
  );

  const [activeTab, setActiveTab] = useState(0);
  return (
    <div className="all-medium-page">

      <Tabs active={activeTab} list={displayList} setActiveTab={setActiveTab} />
      <TabPanel id={0} activeTab={activeTab}>
        <AllFeedback />
      </TabPanel>
      <TabPanel id={1} activeTab={activeTab}>
        <PracticesFeedback />
      </TabPanel>
      <TabPanel id={2} activeTab={activeTab}>
        <CoachingFeedback />
      </TabPanel>
      <TabPanel id={3} activeTab={activeTab}>
        <GroupCoachingFeedback />
      </TabPanel>
      <TabPanel id={4} activeTab={activeTab}>
          <DemonstrationFeedback />
        </TabPanel>
    </div>
  )
}
